export function capitalizeFirstLetter(str: string): string {
  if (str === undefined) {
    // @ts-ignore
    return undefined
  }
  return str.split(" ").map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(" ");
}